import { render, staticRenderFns } from "./vue_jqxtextarea.vue?vue&type=template&id=33f98bbd"
import script from "./vue_jqxtextarea.vue?vue&type=script&lang=js"
export * from "./vue_jqxtextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports